import React from 'react';
import { Outlet } from 'react-router-dom';
import { Toaster } from 'sonner';
import { ParentSidebar } from './ParentSidebar';
import { MobileTabBar } from './MobileTabBar';

/**
 * Parent Layout - Responsive: sidebar on desktop, bottom tabs on mobile
 * Used for: /parent/* (except onboarding which uses PublicLayout)
 */
export const ParentLayout = ({ children }) => {
  return (
    <div className="flex min-h-screen bg-slate-50" data-testid="parent-layout">
      <ParentSidebar />
      <main className="flex-1 px-4 pt-4 pb-24 md:px-8 md:pt-8 md:pb-8">
        <div className="max-w-xl mx-auto md:max-w-5xl">
          {children || <Outlet />}
        </div>
      </main>
      <MobileTabBar />
      <Toaster position="top-right" richColors />
    </div>
  );
};

export default ParentLayout;
